<template>
  <li class="ec-specs-section">
    <div class="ec-section-title" @click="toggleEntry">
      <div class="title-text">
        <img v-if="entryData.image" :src="entryData.image.url" alt=""/>
        {{ entryData.name }}
      </div>
      <span class="chevron" :class="{active: isOpen}"></span>
    </div>
    <div class="ec-section-info"
         :class="{open: isOpen}"
         :style="{height: `${elementHeight}px`}">
      <div ref="sectionWrapper" class="ec-section-info-wrapper">
        <div class="ec-features-wrapper"
             v-for="(feature, index) in entryData.features"
             :key="feature.code + index.toString()">
          <div class="feature-name">{{ feature.name }}</div>
          <div class="feature-value">
            <span v-for="(featureValue, idx) in feature.featureValues"
                 :key="featureValue.code + idx.toString()">
              {{ featureValue.value }}<template v-if="feature.featureUnit"> {{ feature.featureUnit.symbol }} </template><template v-if="idx < feature.featureValues.length - 1">,</template>
            </span>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import mediaQuery from '@/utils/mediaQuery'
export default {
  name: 'device-specification-entry',
  data () {
    return {
      isOpen: false,
      elementHeight: 0
    }
  },
  props: {
    entryData: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      default: '',
      required: true
    }
  },
  methods: {
    toggleEntry () {
      if (mediaQuery(768)) return
      if (this.$parent.$props.allowClose) {
        const valueToEmit = this.isOpen ? null : this.$props.name
        this.$parent.$emit('input', valueToEmit)
      } else {
        this.$parent.$emit('input', this.$props.name)
      }
    }
  },
  watch: {
    isOpen (newVal) {
      this.elementHeight = newVal ? this.$refs.sectionWrapper.getBoundingClientRect().height : 0
    }
  }
}
</script>

<style scoped lang="scss">
.ec-specs-section {
  display: flex;
  flex-direction: column;
  color: $text;

  @media (map_get($breakpoints, sm)) {
    flex-direction: row;
    border-bottom: 1px solid $price-separator;
  }

  .ec-section-title {
    padding: 15px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $price-separator;
    cursor: pointer;

    @media (map_get($breakpoints, sm)) {
      padding: 3.4rem;
      flex: 0 0 33%;
      width: 33%;
      border-bottom: none;
    }

    @media (map_get($breakpoints, lg)) {
      padding: 4rem;
      flex: 0 0 25%;
      width: 25%;
    }

    .title-text {
      font-size: 21px;
      font-weight: 600;
      line-height: 1.37;
      color: #333;
      padding: 0;

      display: flex;
      align-items: center;

      @media (map_get($breakpoints, sm)) {
        font-size: 24px;
        line-height: 1.2;
      }

      img {
        width: 32px;
        height: auto;
        display: inline-block;
        margin-right: 24px;
      }
    }

    .chevron {
      display: inline-block;
      width: 1.2rem;
      height: 1.2rem;
      border: 2px solid $dark-grey;
      border-top: none;
      border-left: none;
      transform: rotate(45deg);
      transition: transform 0.2s;

      @media (map_get($breakpoints, sm)) {
        display: none;
      }

      &.active {
        transform: rotate(225deg);
      }
    }
  }

  .ec-section-info {
    background-color: $white;
    height: 0;
    overflow: hidden;
    opacity: 0;
    transition: height 150ms 150ms, opacity 150ms;

    @media (map_get($breakpoints, sm)) {
      padding: 30px 20px 30px;
      flex: 1 1 66%;
      width: 66%;
      height: auto !important;
      opacity: 1 !important;
    }

    @media (map_get($breakpoints, md)) {
      padding: 20px 80px;
    }

    @media (map_get($breakpoints, lg)) {
      flex: 1 1 75%;
      width: 75%;
    }

    &.open {
      opacity: 1;
      transition: height 150ms, opacity 150ms 150ms;
    }

    .ec-section-info-wrapper {
      padding: 1.6rem;

      @media (map_get($breakpoints, sm)) {
        padding: 0;
      }
    }
  }

  .ec-features-wrapper {
    display: flex;
    flex-direction: column;

    @media (map_get($breakpoints, sm)) {
      flex-direction: row;
    }

    .feature-name, .feature-value {
      font-size: 1.4rem;
      line-height: 1.5;
      flex: 1 1 100%;
      width: 100%;
      display: inline-block;

      @media (map_get($breakpoints, sm)) {
        font-size: 1.6rem;
        line-height: 2.25;
        flex: 1 1 50%;
        width: 50%;
      }
    }

    .feature-name {
      font-weight: 600;

      @media (map_get($breakpoints, lg)) {
        flex-basis: 33%;
        width: 33%;
      }
    }

    .feature-value {
      margin-bottom: 0.8rem;

      @media (map_get($breakpoints, sm)) {
        margin-bottom: 0;
      }

      @media (map_get($breakpoints, lg)) {
        flex-basis: 66%;
        width: 66%;
      }
    }
  }
}
</style>
